import React, { useState, useEffect } from "react";
import { ItemDetail } from "../ItemDetail/ItemDetail";
import { db } from "../../utils/firebase";
import { doc, getDoc } from "firebase/firestore";
import { useParams } from "react-router-dom";

export const ItemDetailContainer = () => {
  const { productId } = useParams();
  const [item, setItem] = useState([]);
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const getProducto = async () => {
      const queryRef = doc(db, "productos", productId);
      const response = await getDoc(queryRef);
      const newItem = {
        id: response.id,
        ...response.data(),
      };
      console.log(newItem.id)
      setTimeout(()=>{
        setItem(newItem);
        setLoading(false)
      }, 500)
    };
    getProducto();

  }, [productId]);

  console.log("item:", item);

  return (
    loading ?  
    <div className="loadingContainer flex justify-center	items-center	">
      <button className="btn btn-square  loading btnLoading"></button>
    </div>
     :
    <div className="flex justify-center items-center w-4/5 m-auto		">
      <ItemDetail {...item} />
    </div>
  );
};
